import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import QRScanner from '../components/QRScanner';
import { parseScan, routeScan } from '../api';

// Jeden univerzální skener: sám pozná vstup do zóny vs. předání materiálu
// a přesměruje na správnou obrazovku.
export default function Scan() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleScan = (text) => {
    setError('');
    const parsed = parseScan(text);
    if (!routeScan(parsed, navigate)) {
      setError('QR kód se nepodařilo rozpoznat. Zkuste to znovu nebo zadejte kód ručně.');
    }
  };

  return (
    <div>
      <AppHeader subtitle="Skenovat QR" />
      <div className="container" style={{ paddingTop: 24 }}>
        <div className="card">
          <h3 className="mb-8">Naskenujte QR kód</h3>
          <p className="text-muted mb-16" style={{ fontSize: '0.88rem' }}>
            Skener sám pozná, jestli jde o <strong>vstup do zóny</strong>, nebo <strong>předání materiálu</strong>,
            a otevře správnou obrazovku.
          </p>
          {error && <div className="alert alert-warning mb-16">{error}</div>}
          <QRScanner onScan={handleScan} onClose={() => navigate('/')} />
        </div>
      </div>
    </div>
  );
}
